import {NgModule} from '@angular/core';
import {RedrawDxWidgetOnElementResizeDirective} from '../dx-directives/redraw-dx-widget-on-element-resize.directive';
import {OnElementResizedDirective} from '../on-element-resized.directive';
import {TransformDirective} from '../transform.directive';
import { ClassHoverDirective } from '../class-hover.directive';

@NgModule({
	declarations: [
		TransformDirective,
		OnElementResizedDirective,
		RedrawDxWidgetOnElementResizeDirective,
		ClassHoverDirective,
	],
	exports: [
		TransformDirective,
		OnElementResizedDirective,
		RedrawDxWidgetOnElementResizeDirective,
		ClassHoverDirective,
	],
	imports: []
})
export class DirectivesModule {}
